'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ActivityFeed = function ActivityFeed(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M10.9,20c-0.4,0-0.8-0.3-1-0.7l-2.9-8l-0.7,2.4c-0.1,0.4-0.5,0.8-1,0.8H2.2c-0.6,0-1-0.5-1-1s0.5-1,1-1h2.4L6,7.6\n\tc0.1-0.4,0.5-0.7,1-0.8c0,0,0,0,0,0c0.5,0,0.9,0.3,1,0.7l2.7,7.7l2.4-10.7c0.1-0.5,0.5-0.8,1-0.8c0.5,0,0.9,0.3,1,0.8l2.2,7.9h1.1\n\tc0.4-0.7,1.2-1.2,2.1-1.2c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4c-0.9,0-1.8-0.6-2.2-1.4h-1.8c-0.5,0-0.9-0.3-1-0.8l-1.3-4.6\n\tL12,19.2C11.9,19.7,11.5,20,10.9,20L10.9,20z"
  }));
};

var Activity = iconStyles()(ActivityFeed);

module.exports = Activity;
